import { cloneElement } from 'react'
import {
  CreateButton,
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  TopToolbar,
  UrlField,
  useListContext,
  useRecordContext,
} from 'react-admin'

import Pill from '../components/pill'

const moment = require('moment')

const SyndicContractsListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)
const ExpirationDatePillWrapper = () => {
  const { id, expiration_date } = useRecordContext()
  let status = 'error'
  const internal_expiration_date = moment(expiration_date)
  if (internal_expiration_date.isSameOrAfter(moment())) status = 'success'
  if (
    internal_expiration_date.isBetween(moment().subtract(3, 'month'), moment())
  )
    status = 'secondary'

  return (
    <Pill
      id={id}
      value={internal_expiration_date.format('D/M/Y')}
      status={status}
    />
  )
}

const ToolbarSyndicContracts = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext()

  return (
    <TopToolbar>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton
        color="secondary"
        variant="contained"
        resource="contracts"
        basePath="contracts"
      />
    </TopToolbar>
  )
}

export const SyndicContractsList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<SyndicContractsListFilter />}
    actions={<ToolbarSyndicContracts />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <UrlField download={true} source="url" />
      <ExpirationDatePillWrapper source="expiration_date" />
    </Datagrid>
  </List>
)
